import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { TripRequestType } from "../../../dashboard/models/trip-request-models";
import { TripRequestService } from "../../../dashboard/services/trip-request.service";
import { TripRequestFormFactory } from "../../shared/trip-request-form.factory";
import { TripRequestFormMapper } from "../../shared/trip-request-form.mapper";
import { TripRequestFormService } from "../../shared/trip-request-form.service";
import { MobileViewAppointmentComponent } from "../appointment/mobile-view-appointment.component";
import { MobileViewTripLocationComponent } from "../trip-location/mobile-view-trip-location.component";
import { MobileViewTripSummaryComponent } from "../trip-summary/mobile-view-trip-summary.component";


@Component({
  selector: 'app-mobile-pre-trip-request',
  standalone: true,
  imports: [
    CommonModule,
    MatStepperModule,
    ReactiveFormsModule,
    MobileViewAppointmentComponent,
    MobileViewTripLocationComponent,
    MobileViewTripSummaryComponent,
    MatDialogModule,
],
  
  templateUrl: './mobile-view-pre-trip-request.component.html',
  styleUrl: './mobile-view-pre-trip-request.component.scss',
})

export class MobileViewPreTripRequestComponent implements OnInit, OnDestroy {
    @Input() requestId: number = 0;
    preTripRequestForm!: FormGroup;
    private tripRequestFormService = inject(TripRequestFormService)
    private tripRequestFormFactory = inject(TripRequestFormFactory);
    private tripRequestFormMapper = inject(TripRequestFormMapper);
    private tripRequestService = inject(TripRequestService);
    private el = inject(ElementRef);
    private dialogRef?: MatDialogRef<any>;
    private dialog = inject(MatDialog);
    private router = inject(Router);
    @ViewChild('confirmationDialogTemplate', { static: true }) confirmationDialogTemplate!: TemplateRef<any>;
    @ViewChild(MobileViewTripLocationComponent) locationComponent!: MobileViewTripLocationComponent
    isCofirmationMessage = true;
    dialogTitle = 'Trip Confirmation';
    dialogContent = '';
    confirmationNo = '';
    activeStepperIndex = 0;


    get tripRequest() : FormGroup {
      return this.preTripRequestForm.get('tripRequest') as FormGroup;
    }

    get tripAppointments() : FormArray {
      return this.tripRequest.get('tripAppointments') as FormArray;
    }

    get tripAddresses() : FormArray {
      return this.tripRequest.get('tripAddresses') as FormArray;
    }

    ngOnInit(): void {
        this.tripRequestFormService.getCountyInfo();
        this.preTripRequestForm = this.tripRequestFormFactory.createPreTripRequestForm();

        if (this.requestId !== 0) {
          this.tripRequestService.getPreTripRequest(this.requestId).subscribe((data) => {
            this.tripRequestFormMapper.loadPreTripRequestData(this.tripRequest, data)
            this.locationComponent.setAddressSearchList();
            this.tripRequestFormService.loadPreTripLegs(this.tripAppointments,data);
            this.activeStepperIndex = data.stepIndex;
          })
        }
        else {
          this.tripAddresses.push(this.tripRequestFormFactory.getTripAddressFg(1));
          this.tripAddresses.push(this.tripRequestFormFactory.getTripAddressFg(2));
        }
    }

    goToAppointment(stepper : MatStepper) {
      stepper.selectedIndex = 0
    }
    

    goToTripLocation(stepper : MatStepper, direction: string) {
      if (direction !== "Back") {
          if (this.tripRequestFormService.validateAppointmentsData(this.tripAppointments)) {
            this.tripRequestFormService.saveAppointments(this.tripRequest, TripRequestType.Pre).subscribe((data) => {
              if(!data.invalidEligibility) { 
                this.tripRequestFormMapper.loadAppointmentData(this.tripRequest, data)
                stepper.selectedIndex = 1;
              }
              else {
                this.dialogTitle = 'Unverified Eligibility';
                this.dialogContent = 'We are unable to verify your eligibility at this time, please contact your local Medical Assistance transportation office for any questions.'
                this.isCofirmationMessage = false;
                this.openDialog(false);
              }
            })
          }
        }
      else {
        stepper.selectedIndex = 1;
      }
    }

    goToSummary(stepper : MatStepper, direction: string) {
        if (direction !== "Back") {
          if (this.tripRequestFormService.validateTripLocation(this.tripRequest)) {
              this.tripRequestFormService.saveTripLocation(this.tripRequest, TripRequestType.Pre).subscribe((data) => {
              if(!data.invalidManualAddress) { 
                this.tripRequestFormMapper.loadAddress(this.tripRequest, data);
                this.tripRequestFormService.loadPreTripLegs(this.tripAppointments, data);
                stepper.selectedIndex = 2;
            }
            else {
                  this.dialogTitle = 'Address Error';
                  this.dialogContent = 'The address entered cannot be verified. Please review the entered information and correct the details, if needed.'
                  this.isCofirmationMessage = false;
                  this.openDialog(false);
            }
          });
        }
      }
      else {
        stepper.selectedIndex = 2;
      }
    }

    saveTripSumary() {
      if (this.tripRequestFormService.validateTripSummary(this.tripRequest, TripRequestType.Pre)) {
        this.tripRequestFormService.saveTripSummary(this.tripRequest, TripRequestType.Pre).subscribe(data => {
          this.confirmationNo = data;
          this.dialogTitle = 'Request Confirmation';
          this.dialogContent = 'The trip has been successfully submitted. Your confirmation number is ' + this.confirmationNo;
          this.isCofirmationMessage = true
          this.openDialog(true);
        })
      }

    }

    openDialog(disableClose: boolean) {
      const rect = this.el.nativeElement.getBoundingClientRect();
      const config = new MatDialogConfig();
      config.width = '80%';
      config.disableClose= disableClose;
      this.dialogRef = this.dialog.open(this.confirmationDialogTemplate, config);
    }

    closeDialog() {
      if (this.isCofirmationMessage) { this.router.navigate(['/dashboard']); }
      this.dialogRef?.close();
    }

    ngOnDestroy(): void {
      this.tripRequestFormService.consumerEnteredMilesSub.forEach(sub => sub.unsubscribe());
    }
}